import { StyledFileUploaderForm } from './style';
import { useIntl } from 'react-intl';
import { Dispatch } from 'react';
import { RequirementProps, Requirements } from './Uploader/Requirements';
import { CustomUploadList } from './Uploader/CustomUploadList';
import { UploadFile } from 'antd/es/upload/interface';
import { message } from 'antd';
import { Uploader } from './Uploader';
import { normalizeFileNames } from 'utils/imageHelpers';
import { options } from 'config/config';

interface FileUploaderProps {
  onFileListChange?: Dispatch<any>;
  fileList: UploadFile[];
  multiple?: boolean;
  requirement?: RequirementProps;
  isCrop?: boolean;
  showActions?: boolean;
  title?: string | null;
  horizontal?: boolean;
  aspectRatio?: number;
  selectedImageName?: string;
  selectable?: boolean;
  setSelectedImageName?: React.Dispatch<
    React.SetStateAction<string | undefined>
  >;
  showDefault?: boolean;
  showRequirement?: boolean;
}

export const FileUploader = ({
  onFileListChange,
  fileList,
  multiple = true,
  requirement,
  isCrop = true,
  showActions = true,
  title,
  horizontal,
  aspectRatio,
  selectedImageName,
  setSelectedImageName,
  selectable,
  showDefault,
  showRequirement = true,
}: FileUploaderProps) => {
  const intl = useIntl();

  const uploaderTitle =
    title === null
      ? null
      : title ||
        (multiple
          ? intl.formatMessage({ id: 'general.gallery_title' })
          : intl.formatMessage({ id: 'general.logo_title' }));

  const handleEditBeforeUpload = async (file: UploadFile) => {
    if (onFileListChange) {
      if (multiple) {
        onFileListChange((files: UploadFile[]) =>
          normalizeFileNames([...files, file])
        );
      } else {
        onFileListChange([file]);
      }
    }
    message.success(intl.formatMessage({ id: 'images.edited_successfully' }));
  };

  const handleRemove = (file: UploadFile) => {
    if (file.name === selectedImageName && setSelectedImageName) {
      setSelectedImageName(undefined);
    }

    const newFileList = fileList.filter((item) => item.uid !== file.uid);
    if (onFileListChange) {
      onFileListChange(newFileList);
    }
  };

  const maxImages = options.images.maxImages;
  const reachedLimit = multiple
    ? fileList.length >= maxImages
    : fileList.length >= 1;

  const canAddMore = !reachedLimit;

  return (
    <StyledFileUploaderForm className={!horizontal ? 'multiple' : ''}>
      {uploaderTitle && (
        <div className={'file-uploader-title'}>{uploaderTitle}</div>
      )}

      <div className={'requirements'}>
        <div className={'uploader-container'}>
          {showRequirement && (
            <Requirements {...(requirement || {})} multiple={multiple} />
          )}
          <div className={'image-upload' + (!canAddMore ? ' capped' : '')}>
            <Uploader
              onFileListChange={onFileListChange}
              fileList={fileList}
              multiple={multiple}
              handleRemove={handleRemove}
              isCrop={isCrop}
              aspectRatio={aspectRatio}
              selectedImageName={selectedImageName}
              setSelectedImageName={setSelectedImageName}
              selectable={selectable}
            />
          </div>
        </div>

        <CustomUploadList
          fileList={fileList}
          onRemove={handleRemove}
          onEdit={handleEditBeforeUpload}
          showActions={showActions}
          aspectRatio={aspectRatio}
          selectedImageName={selectedImageName}
          setSelectedImageName={setSelectedImageName}
          selectable={selectable}
          showDefault={showDefault}
        />
      </div>
    </StyledFileUploaderForm>
  );
};
